import { render, staticRenderFns } from "./admin-user-password.vue?vue&type=template&id=46a85080&scoped=true&"
import script from "./admin-user-password.vue?vue&type=script&lang=js&"
export * from "./admin-user-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a85080",
  null
  
)

export default component.exports